module.exports = __webpack_public_path__ + "img/sun.8bcf39d3.svg";